// File: src/config.js
// Purpose: Central place for environment-based variables.

// Auto-detect environment based on hostname (minimal change)
const isProduction = window.location.hostname === 'touchconnect.org' || 
                    window.location.hostname === 'www.touchconnect.org';

// Dynamic configuration - preserving original structure
export const BASE_URL = isProduction 
  ? "https://www.touchconnect.org/api"  // Production (your original URL)
  : "http://localhost:8000";            // Development (your original URL)

export const IS_DEVELOPMENT = !isProduction;
export const IS_PRODUCTION = isProduction;

// Optional: other service configs (unchanged)
export const AGENTIC_URL = "https://www.aisocket.org/api/integrations/run-once";
export const AI_SERVER_EMAIL = "evagkana@gmail.com";
export const AI_SERVER_PASSWORD = "123";